import { defineMessages } from 'react-intl'

const scope = 'app.components.UserModal'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage:
      '{mode, select, create {Create a new} edit {Edit} delete {Delete} other {}} User{mode, select, view {: {email}} other {}}',
  },
  labels: {
    organization: {
      id: `${scope}.labels.organization`,
      defaultMessage: 'Organization',
    },
    email: {
      id: `${scope}.labels.email`,
      defaultMessage: 'Email',
    },
    firstName: {
      id: `${scope}.labels.firstName`,
      defaultMessage: 'First name',
    },
    lastName: {
      id: `${scope}.labels.lastName`,
      defaultMessage: 'Last name',
    },
    groups: {
      id: `${scope}.labels.groups`,
      defaultMessage: 'Groups',
    },
    roles: {
      id: `${scope}.labels.roles`,
      defaultMessage: 'Role',
    },
    role: {
      id: `${scope}.labels.role`,
      defaultMessage: 'User Role',
    },
    platforms: {
      id: `${scope}.labels.platforms`,
      defaultMessage: 'Platforms',
    },
  },
  formFeedback: {
    invalidEmail: {
      id: `${scope}.formFeedback.invalidEmail`,
      defaultMessage: 'Invalid email address',
    },
    emailUnavailable: {
      id: `${scope}.formFeedback.emailUnavailable`,
      defaultMessage: 'This email address is already in use by another user',
    },
  },
  roles: {
    basicUser: {
      id: `${scope}.roles.basicUser`,
      defaultMessage: 'Basic User',
    },
    admin: {
      id: `${scope}.roles.admin`,
      defaultMessage: 'Admin',
    },
    superuser: {
      id: `${scope}.roles.superuser`,
      defaultMessage: 'Superuser',
    },
  },
})
